var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component } from 'react';
import classnames from 'classnames';
import { HtmlSpan } from '../../reset/HtmlSpan/HtmlSpan';
import { Menu, MenuButton, MenuList, MenuItem, } from '@reach/menu-button';
import { logger } from '../../utils/logger';
import '@reach/menu-button/styles.css';
export { MenuItem as DropdownItem };
var baseClassName = 'fi-dropdown';
var buttonClassName = baseClassName + "_button";
var dropdownListClassName = baseClassName + "_list";
var dropdownItemClassName = baseClassName + "_item";
var Dropdown = (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { selectedName: undefined };
        _this.changeName = function (name) { return _this.setState({ selectedName: name }); };
        _this.list = function (children, changeNameToSelection, dropdownItemProps) {
            return React.Children.map(children, function (child) {
                var childChildren = child.props.children;
                var isChildString = !!changeNameToSelection &&
                    !!childChildren &&
                    typeof childChildren === 'string';
                if (React.isValidElement(child)) {
                    return React.cloneElement(child, __assign({}, dropdownItemProps, (!!isChildString && {
                        onSelect: function () {
                            child.props.onSelect();
                            _this.changeName.bind(_this)(childChildren);
                        },
                    })));
                }
                return child;
            });
        };
        return _this;
    }
    Dropdown.prototype.render = function () {
        var _a = this.props, children = _a.children, name = _a.name, className = _a.className, _b = _a.dropdownButtonProps, dropdownButtonProps = _b === void 0 ? {} : _b, _c = _a.dropdownListProps, dropdownListProps = _c === void 0 ? {} : _c, MenuListComponentReplace = _a.menuListComponent, _d = _a.dropdownItemProps, dropdownItemProps = _d === void 0 ? {} : _d, _e = _a.changeNameToSelection, changeNameToSelection = _e === void 0 ? true : _e, passProps = __rest(_a, ["children", "name", "className", "dropdownButtonProps", "dropdownListProps", "menuListComponent", "dropdownItemProps", "changeNameToSelection"]);
        if (React.Children.count(children) < 1) {
            logger.warn("Dropdown '" + name + "' does not contain items");
            return null;
        }
        var selectedName = this.state.selectedName;
        var passDropdownButtonProps = __assign({}, dropdownButtonProps, { className: classnames(buttonClassName, dropdownButtonProps.className) });
        var passDropdownListProps = __assign({}, dropdownListProps, { className: classnames(dropdownListClassName, dropdownListProps.className) });
        var passDropdownItemProps = __assign({}, dropdownItemProps, { className: classnames(dropdownItemClassName, dropdownItemProps.className) });
        return (React.createElement(HtmlSpan, { className: classnames(className, baseClassName) },
            React.createElement(Menu, __assign({}, passProps),
                React.createElement(MenuButton, __assign({}, passDropdownButtonProps), !!selectedName ? selectedName : name),
                !!MenuListComponentReplace ? (React.createElement(MenuListComponentReplace, __assign({}, passDropdownListProps), this.list(children, changeNameToSelection, passDropdownItemProps))) : (React.createElement(MenuList, __assign({}, passDropdownListProps), this.list(children, changeNameToSelection, passDropdownItemProps))))));
    };
    return Dropdown;
}(Component));
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map